import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import { addEventListener } from '@ifeng/ui_base';
import Ad from '@ifeng/ui_pc_ad';

import TopicTitle from '../../../components/topicTitle';
import TopicTop from '../../../components/topicTop';
import TopicList from '../../../components/topicList';

class TopicHumanity extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        stream: PropTypes.array,
        ad: PropTypes.object,
    };

    render() {
        const { content, stream, ad } = this.props;

        return (
            <div className={styles.Topic}>
                <TopicTitle title={'人文'} />
                <Chip id="75176" type="recommend" title="视频首页-人文" groupName="正文" content={content}>
                    <TopicTop />
                </Chip>
                <TopicList content={stream} ad={ad} />
            </div>
        );
    }
}

export default TopicHumanity;
